import { render, staticRenderFns } from "./UserRosterTable.vue?vue&type=template&id=8e8df800"
import script from "./UserRosterTable.vue?vue&type=script&lang=js"
export * from "./UserRosterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports